export default __webpack_public_path__ + "static/media/airfreight.793e7073.svg";